var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}pause`,"viewBox":"0 0 16 16"}},[_c('circle',{staticClass:"base",attrs:{"cx":"8","cy":"8","r":"8"}}),_c('rect',{staticClass:"sign",attrs:{"x":"9","y":"5","width":"2","height":"6"}}),_c('rect',{staticClass:"sign",attrs:{"x":"5","y":"5","width":"2","height":"6"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }